<template>
  <div class="login-page">
    <div class="top-right-circle">
      <new-circle-component />
    </div>
    <div class="bottom-left-circle">
      <new-circle-component />
    </div>

    <div class="login-container">
      <div class="smartwatch-icon">
        <img src="../assets/icons/logo-miles-web.svg" alt />
      </div>
      <button-component
        variant="outlined"
        color="white"
        @click.native="onLoginClick"
        >Login</button-component
      >
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import { RouteName } from '../utils/enums';
import ButtonComponent from '../components/button.component';
import NewCircleComponent from '../components/new-circle.component';
import { Api } from '../api/api';

export default {
  name: 'login-page',
  components: {
    ButtonComponent,
    NewCircleComponent
  },
  data: function() {
    return {
      email: 'test',
      password: 'test'
    };
  },
  methods: {
    onLostPasswordClick: function() {
      this.$router.push({ name: RouteName.LOST_PASSWORD });
    },
    onLoginClick: function() {
      // This will redirect to the login page of the provider.
      this.$store.dispatch('LOGIN');
    }
  }
};
</script>

<style scoped lang="scss">
.login-page {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-color: $primary;
  background-size: 100% auto;
  background-position: bottom;
}

.top-right-circle,
.bottom-left-circle {
  width: 236px;
  height: 236px;
  position: absolute;
  overflow: hidden;
  display: flex;
}

.top-right-circle {
  top: 0;
  right: 0;
  justify-content: flex-start;
  align-items: flex-end;
}

.bottom-left-circle {
  bottom: 0;
  left: 0;
  justify-content: flex-end;
}

.login-container {
  width: 335px;
  position: relative;
  z-index: 9;
}

.button-component {
  margin-top: 60px;
}
</style>
